/**
 * 海报相关接口
 * @author wuzhouyang
 * @since 2021-11-01
 */
import { get } from '@fe/common/lib/ajax';

/**
 * 获取常用海报尺寸
 * @param params
 */
export function getPosterSizeList() {
  const uri = `/api/store/poster/customPosterSizes`;
  return get(uri);
}
